var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_209_751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33329 8.66678C8.23064 8.66678 7.33331 7.76945 7.33331 6.6668C7.33331 5.56415 8.23064 4.66682 9.33329 4.66682H10.6665V2.00022C10.6665 0.897574 9.76919 0.000244141 8.66654 0.000244141H1.49999C1.28063 0.000244141 1.07531 0.108153 0.950681 0.288815C0.826659 0.469478 0.798705 0.699578 0.877318 0.904165L5.71064 13.5708C5.80866 13.8294 6.05658 14.0001 6.33332 14.0001H8.66654C9.76919 14.0001 10.6665 13.1028 10.6665 12.0001V8.66678H9.33329Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4112 9.94935C12.1626 9.84596 11.9999 9.60267 11.9999 9.33327V7.33329H9.33328C8.96524 7.33329 8.66653 7.03471 8.66653 6.66667C8.66653 6.29863 8.96524 6.00005 9.33328 6.00005H11.9999V4.00007C11.9999 3.73067 12.1626 3.48738 12.4112 3.38399C12.6605 3.28072 12.9473 3.33809 13.1378 3.52876L15.8045 6.19536C16.0651 6.45598 16.0651 6.87736 15.8045 7.13798L13.1378 9.8047C12.9473 9.99525 12.6605 10.0526 12.4112 9.94935Z",
    fill: "#607D8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.76398 1.40137L1.75804 0.0660539C0.853995 -0.211897 0 0.455454 0 1.33337V13.3332C0 13.9033 0.362667 14.412 0.9027 14.5986L4.90791 15.9339C5.05524 15.9792 5.19062 16 5.33332 16C6.06866 16 6.66656 15.402 6.66656 14.6666V2.66673C6.66656 2.09679 6.30389 1.58813 5.76398 1.40137Z",
    fill: "#64B5F6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_209_751"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.9c752b9b8644a3a5ce1e74ac6c91f512.svg";
export { ForwardRef as ReactComponent };